import React from 'react';
import { AuthLayout } from '../../components/layout/Layouts'; 
import DashboardIndex from '../../components/Dashboard/DashboardIndex'; 

const DashboardPage = () => {
  return (
    <AuthLayout>
      <DashboardIndex />
    </AuthLayout>
  );
};

export default DashboardPage;
